export default {
  "content": "<path d=\"M12 4a8 8 0 108 8h2c0 5.522-4.477 10-10 10S2 17.522 2 12C2 6.476 6.477 2 12 2v2z\" fill=\"#7B61FF\"/><path d=\"M15.895 14.448C15.159 15.918 13.728 17 12 17c-1.728 0-3.159-1.083-3.895-2.552l1.79-.897C10.356 14.473 11.164 15 12 15c.836 0 1.644-.526 2.105-1.448l1.79.897zM19 5h4v2h-4v4h-2V7h-4V5h4V1h2v4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};